module.exports = __webpack_public_path__ + "static/media/3DPPA40.1c61b286.jpg";